(() => {
  const bar = document.querySelector('[data-mobile-sticky-bar]');
  if (!bar) return;

  const bottomOffset = 20;

  let rafId = null;
  let lastHeight = -1;

  const updateHeight = () => {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }

    rafId = requestAnimationFrame(() => {
      const height = bar.getBoundingClientRect().height;
      const finalHeight = Math.round(height + bottomOffset);

      if (finalHeight !== lastHeight) {
        document.documentElement.style.setProperty(
          '--mobile-sticky-bar-height',
          `${finalHeight}px`
        );

        lastHeight = finalHeight;
      }

      rafId = null;
    });
  };

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(bar);
  } else {
    window.addEventListener('resize', updateHeight, { passive: true });
  }

  window.addEventListener('pageshow', updateHeight);

  updateHeight();
})();
